const doc = [({"en":({"consultViaPlatform":"Consult via {{platform}}", "consultViaPlatformShort":"Consult via {{platform}}", "forCruiseConsultation":"Click here for cruise consultation"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;